
const digest = '241be7ec9b54ada7224e169fe4ea871b92e79e2c67767d5affecc2c00b4a348f';
const classes = {"wrapper":"_wrapper_14vaj_1","header":"_header_14vaj_10","iconWrapper":"_iconWrapper_14vaj_17","title":"_title_14vaj_31","description":"_description_14vaj_36","content":"_content_14vaj_40","list":"_list_14vaj_45","item":"_item_14vaj_50","icon":"_icon_14vaj_17","text":"_text_14vaj_72","footer":"_footer_14vaj_76"};
const css = `._wrapper_14vaj_1 {
  display: flex;
  flex-direction: column;
  margin: -34px -24px;
  border-radius: 25px;
  font-family: Rubik, "sans-serif";
  overflow: hidden;
  background: #ffffff;
}
._wrapper_14vaj_1 ._header_14vaj_10 {
  padding: 40px 100px 40px 40px;
  background: radial-gradient(circle at 85% 10%, rgba(180, 204, 60, 0.22), transparent 55%), radial-gradient(circle at 15% 90%, rgba(30, 106, 216, 0.18), transparent 55%), linear-gradient(135deg, #F4F8FD 0%, #EAF1FB 100%);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_14vaj_1 ._header_14vaj_10 ._iconWrapper_14vaj_17 {
  height: 70px;
  width: 70px;
  border-radius: 15px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1D65D8;
  background: linear-gradient(53deg, rgb(29, 101, 216) 0%, rgb(53, 122, 232) 100%);
}
._wrapper_14vaj_1 ._header_14vaj_10 ._iconWrapper_14vaj_17 img {
  height: 40px;
}
._wrapper_14vaj_1 ._header_14vaj_10 ._title_14vaj_31 {
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
}
._wrapper_14vaj_1 ._header_14vaj_10 ._description_14vaj_36 {
  font-weight: 400;
  font-size: 15px;
}
._wrapper_14vaj_1 ._content_14vaj_40 {
  display: flex;
  flex-direction: column;
  padding: 40px;
}
._wrapper_14vaj_1 ._content_14vaj_40 ._list_14vaj_45 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_14vaj_1 ._content_14vaj_40 ._list_14vaj_45 ._item_14vaj_50 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
._wrapper_14vaj_1 ._content_14vaj_40 ._list_14vaj_45 ._item_14vaj_50 ._icon_14vaj_17 {
  background: #cedcf3;
  height: 25px;
  width: 25px;
  border-radius: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
._wrapper_14vaj_1 ._content_14vaj_40 ._list_14vaj_45 ._item_14vaj_50 ._icon_14vaj_17 img {
  height: 8px;
}
._wrapper_14vaj_1 ._content_14vaj_40 ._list_14vaj_45 ._item_14vaj_50 ._title_14vaj_31 {
  font-weight: 600;
  font-size: 14px;
}
._wrapper_14vaj_1 ._content_14vaj_40 ._list_14vaj_45 ._item_14vaj_50 ._text_14vaj_72 {
  font-size: 13px;
  color: #6b7687;
}
._wrapper_14vaj_1 ._footer_14vaj_76 {
  border-top: 1px solid #e6eaf0;
  padding: 20px;
  display: flex;
  justify-content: flex-end;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  